// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3O5x0","topBottomGutter":"Layout_topBottomGutter__HLBI1"};